import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const withMidLang = (lang, prefix, suffix) =>
  lang ? `${prefix}/${lang}/${suffix}` : `${prefix}/${suffix}`;

export const apiHome = createApi({
  reducerPath: "apiHome",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_PUBLIC_URL}/`,
  }),

  endpoints: (builder) => ({
    getApi: builder.query({
      query: ({ url, lang }) => `${lang}/api/v1/${url}`,
    }),
    getTechno: builder.query({
      query: ({ lang }) => withMidLang(lang, "/api/tenders", "searchtechno"),
    }),

    getHtmlApi: builder.query({
      query: ({ url, lang }) => `${lang}/node/${url}?_format=json`,
    }),

    getTenderApi: builder.query({
      query: ({ page, title, lang }) =>
        withMidLang(lang, "api/v1", `searchpage2?page=${page}&title=${title}`),
    }),

    getArchivedTenderApi: builder.query({
      query: ({ page, title, lang }) =>
        withMidLang(
          lang,
          "api/v1",
          `tendersarchive?page=${page}&title=${title}`,
        ), // MIDDLE fix
    }),

    getSuccessfulBiddersApi: builder.query({
      query: ({ page, title, lang }) =>
        withMidLang(
          lang,
          "api/tenders",
          `successfulbid?page=${page}&title=${title}`,
        ), // MIDDLE fix
    }),

    // reservoir list  Data
    getWaterLevelData: builder.query({
      query: ({ damInfo, lang }) => `${lang}/api/v1/${damInfo}`,
    }),
    getRainFallLevelData: builder.query({
      query: ({ damInfo, lang }) => `${lang}/api/v1/${damInfo}`,
    }),

    // feedback api
    getFeedbackData: builder.mutation({
      query: ({ url, payload }) => ({
        url,
        method: "POST",
        body: payload,
        headers: {
          "Content-Type": "application/json",
        },
      }),
    }),
    getVisitorsCount: builder.query({
      query: (url) => `v1/${url}`,
    }),

    getWaterLevelAPI: builder.query({
      query: ({ date, damId }) =>
        `/api/water-level/search?date=${date}&dm_id=${damId}`,
    }),
    getRainFallAPI: builder.query({
      query: ({ date, damId }) =>
        `/api/rain_fall/search?date=${date}&dm_id=${damId}`,
    }),
    getSearchAPI: builder.query({
      query: ({ query, page, category, fromDate, toDate }) =>
        `/api/global-search?q=${query}&page=${page}&type=${category}&f_date=${fromDate}&to_date=${toDate}`,
    }),
    getCsrGalleryApi: builder.query({
      query: ({ url }) => `/api/v1/${url}`,
    }),
    // getStatusOfGeneration: builder.query({
    //   query: ({ query, lang }) =>
    //     `/api/v1/${lang}/generation-details?dm=${query}`,
    // }),

    getStatusOfGeneration: builder.query({
      query: ({ query, lang }) =>
        withMidLang(lang, "api/v1", `generation-details?dm=${query}`), // MIDDLE fix
    }),
    getCaptchaImage: builder.query({
      query: () => `/image-captcha-refresh/image_captcha_settings`,
    }),
    getPropertyReturn: builder.query({
      query: ({ name, year }) =>
        `/api/employee?employee_name=${name}&year=${year}`,
    }),
  }),
});

export const {
  useGetWaterLevelDataQuery,
  useGetApiQuery,
  useGetFeedbackDataMutation,
  useGetHtmlApiQuery,
  useGetVisitorsCountQuery,
  useGetWaterLevelAPIQuery,
  useLazyGetWaterLevelAPIQuery,
  useGetRainFallAPIQuery,
  useGetTenderApiQuery,
  useGetArchivedTenderApiQuery,
  useGetTechnoQuery,
  useGetSearchAPIQuery,
  useGetCsrGalleryApiQuery,
  useGetStatusOfGenerationQuery,
  useGetCaptchaImageQuery,
  useGetPropertyReturnQuery,
  useGetSuccessfulBiddersApiQuery,
} = apiHome;
